/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosChecklistsChecklistItemStateDto,
  FacilityFlowCoreModulesPlanningDtosChecklistsMyDayChecklistsDto,
  FacilityFlowCoreModulesPlanningDtosChecklistsMyOpenChecklistsDto,
  GetApiV1MeChecklistsOpenParams,
  GetApiV1MeChecklistsParams,
  PostApiV1MeChecklistsCompleteBody
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getMeChecklists = () => {
/**
 * @summary Checklisten aller Aufgaben, die für den angemeldeten Mitarbeiter an diesem Tag
geplant sind — inklusive bereits abgehakter Punkte. Ohne `date`: heute.
 */
const getApiV1MeChecklists = (
    params?: GetApiV1MeChecklistsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsMyDayChecklistsDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsMyDayChecklistsDto>(
      {url: `/api/v1/me/checklists`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Noch offene Checklistenpunkte vergangener Tage — der heutige Tag bleibt außen vor,
den liefert der Aufruf ohne `date`. Aufgeführt sind nur Aufgaben mit mindestens
einem offenen Punkt, jeweils mit ihrer vollständigen Liste. Mit
`includeCompleted` kommen auch vollständig erledigte Aufgaben dazu, begrenzt auf
Tage ab `from` (Standard: die letzten 14 Tage). Offene bleiben immer enthalten.
 */
const getApiV1MeChecklistsOpen = (
    params?: GetApiV1MeChecklistsOpenParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsMyOpenChecklistsDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsMyOpenChecklistsDto>(
      {url: `/api/v1/me/checklists/open`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Checklistenpunkt bestätigen. Punkte mit Foto-Pflicht brauchen die Datei
`photo`; ohne sie schlägt der Aufruf mit `planning.checklists.photoRequired` fehl.
 */
const postApiV1MeChecklistsComplete = (
    postApiV1MeChecklistsCompleteBody: PostApiV1MeChecklistsCompleteBody,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsChecklistItemStateDto>>,) => {const formData = new FormData();
if(postApiV1MeChecklistsCompleteBody.date !== undefined) {
 formData.append(`date`, postApiV1MeChecklistsCompleteBody.date)
 }
if(postApiV1MeChecklistsCompleteBody.taskId !== undefined) {
 formData.append(`taskId`, postApiV1MeChecklistsCompleteBody.taskId)
 }
if(postApiV1MeChecklistsCompleteBody.checklistItemId !== undefined) {
 formData.append(`checklistItemId`, postApiV1MeChecklistsCompleteBody.checklistItemId)
 }
if(postApiV1MeChecklistsCompleteBody.note !== undefined) {
 formData.append(`note`, postApiV1MeChecklistsCompleteBody.note)
 }
if(postApiV1MeChecklistsCompleteBody.photo !== undefined) {
 formData.append(`photo`, postApiV1MeChecklistsCompleteBody.photo)
 }

      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsChecklistItemStateDto>(
      {url: `/api/v1/me/checklists/complete`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * @summary Bestätigung zurücknehmen (Fehlklick). Ein hinterlegtes Foto wird mitgelöscht.
 */
const deleteApiV1MeChecklistsCompletionsCompletionId = (
    completionId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/checklists/completions/${completionId}`, method: 'DELETE'
    },
      options);
    }
  return {getApiV1MeChecklists,getApiV1MeChecklistsOpen,postApiV1MeChecklistsComplete,deleteApiV1MeChecklistsCompletionsCompletionId}};
export type GetApiV1MeChecklistsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeChecklists>['getApiV1MeChecklists']>>>
export type GetApiV1MeChecklistsOpenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeChecklists>['getApiV1MeChecklistsOpen']>>>
export type PostApiV1MeChecklistsCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeChecklists>['postApiV1MeChecklistsComplete']>>>
export type DeleteApiV1MeChecklistsCompletionsCompletionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeChecklists>['deleteApiV1MeChecklistsCompletionsCompletionId']>>>
